import gql from 'graphql-tag';

export const _GET_TEMPLATES = gql`
	query getTemplates(
		$legalEntityFilter: [risolto_communication_template_bool_exp!]
		$participant: uuid
		$channels: [risolto_channel_enum!]
		$searchTerm: String
		$locales: [String!]
		$toneOfVoices: [risolto_tone_of_voice_enum!]
		$orderBy: [risolto_communication_template_order_by!]
		$limit: Int!
		$offset: Int!
	) {
		total: risolto_communication_template_aggregate(
			order_by: $orderBy
			where: {
				_and: [
					{ participant: { _eq: $participant } }
					{ channel: { _in: $channels } }
					{ locale: { _in: $locales } }
					{ tone_of_voice: { _in: $toneOfVoices } }
					{ _and: $legalEntityFilter }
					{ _or: [{ template_id: { _ilike: $searchTerm } }, { locale: { _ilike: $searchTerm } }, { legal_entity_by_reference: { registration_name: { _ilike: $searchTerm } } }] }
				]
			}
		) {
			aggregate {
				count
			}
		}
		templates: risolto_communication_template(
			limit: $limit
			offset: $offset
			order_by: $orderBy
			where: {
				_and: [
					{ participant: { _eq: $participant } }
					{ channel: { _in: $channels } }
					{ locale: { _in: $locales } }
					{ tone_of_voice: { _in: $toneOfVoices } }
					{ _and: $legalEntityFilter }
					{ _or: [{ template_id: { _ilike: $searchTerm } }, { locale: { _ilike: $searchTerm } }, { legal_entity_by_reference: { registration_name: { _ilike: $searchTerm } } }] }
				]
			}
		) {
			reference
			participant
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
			}
			template_id
			channel
			document_name
			tone_of_voice
			type
			locale
		}
	}
`;

export const _GET_TEMPLATE = gql`
	query getTemplate($reference: uuid) {
		template: risolto_communication_template(where: { reference: { _eq: $reference } }) {
			reference
			participant
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
			}
			template_id
			subject_template
			channel
			document_name
			tone_of_voice
			type
			locale
			template_renderer_version
			document_template
		}
	}
`;

export const _UPDATE_COMMUNICATION_TEMPLATE = gql`
	mutation updateCommunicationTemplate($document_template: jsonb, $template_reference: uuid, $subject_template: String) {
		update_risolto_communication_template(where: { reference: { _eq: $template_reference } }, _set: { document_template: $document_template, subject_template: $subject_template }) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;
